export const reactionCollection = {
  thumbsup: '👍',
  thumbsdown: '👎'
}
